import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { API_URL } from '../config';

const TEXT = {
  es: {
    title: 'Salir del equipo',
    description: 'Dejar\u00e1s de tener acceso a los datos de esta empresa. Para volver, un administrador tendr\u00e1 que invitarte de nuevo.',
    button: 'Salir del equipo',
    leaving: 'Saliendo...',
    confirmLeave: '\u00bfSeguro que quieres salir del equipo? Se cerrar\u00e1 tu sesi\u00f3n.',
    confirmRemove: '\u00bfSeguro que quieres quitar a {{email}} del equipo?',
    error: 'No se pudo salir del equipo.',
    adminOnly: 'Solo un administrador puede cambiar estos datos.',
    owner: 'Propietario',
    you: 'T\u00fa',
  },
  en: {
    title: 'Leave team',
    description: 'You will lose access to this company\u2019s data. To come back, an administrator will have to invite you again.',
    button: 'Leave team',
    leaving: 'Leaving...',
    confirmLeave: 'Are you sure you want to leave the team? You will be logged out.',
    confirmRemove: 'Are you sure you want to remove {{email}} from the team?',
    error: 'Could not leave the team.',
    adminOnly: 'Only an administrator can change these settings.',
    owner: 'Owner',
    you: 'You',
  },
  fr: {
    title: 'Quitter l\u2019\u00e9quipe',
    description: 'Vous n\u2019aurez plus acc\u00e8s aux donn\u00e9es de cette entreprise. Pour revenir, un administrateur devra vous inviter \u00e0 nouveau.',
    button: 'Quitter l\u2019\u00e9quipe',
    leaving: 'D\u00e9part en cours...',
    confirmLeave: 'Voulez-vous vraiment quitter l\u2019\u00e9quipe ? Vous serez d\u00e9connect\u00e9.',
    confirmRemove: 'Voulez-vous vraiment retirer {{email}} de l\u2019\u00e9quipe ?',
    error: 'Impossible de quitter l\u2019\u00e9quipe.',
    adminOnly: 'Seul un administrateur peut modifier ces informations.',
    owner: 'Propri\u00e9taire',
    you: 'Vous',
  },
};

export const getTeamText = (lang) => TEXT[(lang || 'es').slice(0, 2)] || TEXT.es;

export function useTeamText() {
  const { i18n } = useTranslation();
  return getTeamText(i18n.language);
}

function LeaveTeamCard({ token, onLeft }) {
  const tx = useTeamText();
  const [leaving, setLeaving] = useState(false);
  const [error, setError] = useState('');

  const leave = async () => {
    if (!window.confirm(tx.confirmLeave)) return;
    setLeaving(true);
    setError('');
    try {
      await axios.post(`${API_URL}/api/v1/team/leave`, {}, { headers: { Authorization: `Bearer ${token}` } });
      onLeft();
    } catch (err) {
      const detail = err.response && err.response.data && err.response.data.detail;
      setError(typeof detail === 'string' ? detail : tx.error);
      setLeaving(false);
    }
  };

  return (
    <div className="bg-surface border border-edge rounded-2xl p-5 sm:p-6 max-w-lg mb-6">
      <p className="text-white text-sm font-semibold mb-1">{tx.title}</p>
      <p className="text-muted text-xs mb-4">{tx.description}</p>
      {error && (
        <div className="bg-[#2a0f0f] border border-[#7f1d1d] text-red-400 text-sm rounded-lg p-3 mb-3">{error}</div>
      )}
      <button
        type="button"
        onClick={leave}
        disabled={leaving}
        className="text-red-400 text-sm px-4 py-2 rounded-lg border border-[#7f1d1d] cursor-pointer"
      >
        {leaving ? tx.leaving : tx.button}
      </button>
    </div>
  );
}

export default LeaveTeamCard;